import { jsx as _jsx } from "react/jsx-runtime";
import { TableRowStyled } from './ReceiptItemTableRow.styled';
// TODO: to delete later LEGACY
const ReceiptItemTableRow = (props) => {
    return _jsx(TableRowStyled, { ...props });
};
export { ReceiptItemTableRow };
